module.exports = "/_next/static/images/hybrid-a24ce91afc0cee5ad167566ddc05d66b.png";